(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["one-bone-category-micro-nav"] && !Shopify.designMode) return;
  try {
    (() => {
    function initOBMicroNavBlocks(container = document) {
      const blocks = container.querySelectorAll('[data-ob-micro-nav-block]');

      blocks.forEach((navBlock) => {
        if (navBlock.dataset.obMicroInitialized === 'true') return;

        const rail = navBlock.querySelector('[data-ob-micro-rail]');
        const railWrap = navBlock.querySelector('.ob-micro-nav__rail-wrap');
        const items = Array.from(navBlock.querySelectorAll('[data-ob-micro-item]'));
        const prev = navBlock.querySelector('[data-ob-micro-prev]');
        const next = navBlock.querySelector('[data-ob-micro-next]');
        const matchCurrentUrl = navBlock.dataset.matchCurrentUrl === 'true';

        if (!rail || items.length === 0) return;

        navBlock.dataset.obMicroInitialized = 'true';

        function setActiveItem(activeItem) {
          items.forEach((item) => {
            const isActive = item === activeItem;
            item.classList.toggle('is-active', isActive);
            item.setAttribute('aria-current', isActive ? 'page' : 'false');
          });
        }

        function scrollRail(direction) {
          if (!railWrap || !railWrap.classList.contains('has-overflow')) return;
          const amount = Math.max(rail.clientWidth * 0.72, 220);
          rail.scrollBy({ left: amount * direction, behavior: 'smooth' });
        }

        let resizeFrame = null;

        function updateOverflowState() {
          if (!railWrap) return;

          const hasOverflow = rail.scrollWidth > rail.clientWidth + 2;
          railWrap.classList.toggle('has-overflow', hasOverflow);

          if (prev) prev.disabled = !hasOverflow;
          if (next) next.disabled = !hasOverflow;
        }

        function scheduleOverflowUpdate() {
          if (resizeFrame) window.cancelAnimationFrame(resizeFrame);
          resizeFrame = window.requestAnimationFrame(updateOverflowState);
        }

        items.forEach((item) => {
          item.addEventListener('click', () => setActiveItem(item));
        });

        if (prev) {
          prev.addEventListener('click', () => scrollRail(-1));
        }

        if (next) {
          next.addEventListener('click', () => scrollRail(1));
        }

        updateOverflowState();
        window.addEventListener('resize', scheduleOverflowUpdate, { passive: true });

        if ('ResizeObserver' in window) {
          const observer = new ResizeObserver(scheduleOverflowUpdate);
          observer.observe(rail);
          observer.observe(navBlock);
        }

        if (matchCurrentUrl) {
          const currentPath = window.location.pathname.replace(/\/$/, '');
          const currentUrl = window.location.href.replace(/\/$/, '');
          const matchedItem = items.find((item) => {
            const itemHref = item.href.replace(/\/$/, '');
            const itemPath = new URL(item.href, window.location.origin).pathname.replace(/\/$/, '');
            return itemHref === currentUrl || itemPath === currentPath;
          });

          if (matchedItem) {
            setActiveItem(matchedItem);
            matchedItem.scrollIntoView({ behavior: 'smooth', inline: 'center', block: 'nearest' });
          }
        }
      });
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', () => initOBMicroNavBlocks());
    } else {
      initOBMicroNavBlocks();
    }

    document.addEventListener('shopify:section:load', (event) => {
      initOBMicroNavBlocks(event.target);
    });
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["onebone-campaign-composer"] && !Shopify.designMode) return;
  try {
    if (!window.oneboneKlaviyoCampaignReady) {
    window.oneboneKlaviyoCampaignReady = true;
    document.addEventListener('click', (event) => {
      const trigger = event.target.closest('[data-ob-klaviyo-form]');
      if (!trigger) return;
      const formId = trigger.dataset.obKlaviyoForm;
      if (!formId) return;
      window._klOnsite = window._klOnsite || [];
      window._klOnsite.push(['openForm', formId]);
    });
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["onebone-okendo-registration"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('onebone-okendo-registration')) {
    class OneboneOkendoRegistration extends HTMLElement {
      connectedCallback() {
        if (this.dataset.initialized === 'true') return;
        this.dataset.initialized = 'true';
        this.button = this.querySelector('[data-okendo-launch]');
        this.status = this.querySelector('[data-okendo-status]');
        this.button?.addEventListener('click', () => this.launch());
        if (this.dataset.autoLaunch === 'true') {
          this.observer = new IntersectionObserver((entries) => {
            if (!entries[0]?.isIntersecting) return;
            this.observer.disconnect();
            this.launch();
          }, { threshold: .45 });
          this.observer.observe(this);
        }
      }

      launch() {
        const eventName = this.dataset.okendoEvent;
        const fallbackUrl = this.dataset.fallbackUrl;
        if (window.okeConnectApi?.raiseCustomEvent && eventName) {
          if (this.status) this.status.textContent = this.dataset.openingLabel || 'OPENING REGISTRATION…';
          window.okeConnectApi.raiseCustomEvent(eventName, this.dataset.forceShow === 'true');
          window.setTimeout(() => { if (this.status) this.status.textContent = ''; }, 1800);
          return;
        }
        if (fallbackUrl) {
          window.location.assign(fallbackUrl);
          return;
        }
        if (this.status) this.status.textContent = this.dataset.errorLabel || 'REGISTRATION IS NOT AVAILABLE YET.';
      }
    }
    customElements.define('onebone-okendo-registration', OneboneOkendoRegistration);
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["onebone-reset-checklist"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('onebone-reset-checklist')) {
    class OneboneResetChecklist extends HTMLElement {
      connectedCallback() {
        if (this.dataset.initialized === 'true') return;
        this.dataset.initialized = 'true';
        this.tasks = Array.from(this.querySelectorAll('[data-reset-task]'));
        this.percent = this.querySelector('[data-reset-percent]');
        this.status = this.querySelector('[data-reset-status]');
        this.meter = this.querySelector('[data-reset-meter]');
        this.meterFill = this.querySelector('[data-reset-meter-fill]');
        this.clearButton = this.querySelector('[data-reset-clear]');
        this.tasks.forEach((task) => task.addEventListener('change', () => this.updateProgress()));
        if (this.clearButton) {
          this.clearButton.addEventListener('click', () => {
            this.tasks.forEach((task) => { task.checked = false; });
            this.updateProgress();
            this.tasks[0]?.focus();
          });
        }
        this.updateProgress();
      }

      updateProgress() {
        const total = this.tasks.length;
        const completed = this.tasks.filter((task) => task.checked).length;
        const value = total ? Math.round((completed / total) * 100) : 0;
        const template = this.dataset.progressTemplate || '{done} OF {total} DONE';
        const status = completed === total && total > 0
          ? (this.dataset.completeLabel || 'YOU’RE READY.')
          : template.replace('{done}', completed).replace('{total}', total);
        if (this.percent) this.percent.textContent = `${value}%`;
        if (this.status) this.status.textContent = status;
        if (this.meter) this.meter.setAttribute('aria-valuenow', value);
        if (this.meterFill) this.meterFill.style.width = `${value}%`;
        if (this.clearButton) this.clearButton.dataset.visible = completed > 0 ? 'true' : 'false';
      }
    }
    customElements.define('onebone-reset-checklist', OneboneResetChecklist);
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["onebone-room-shopper"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('onebone-room-shopper')) {
    class OneboneRoomShopper extends HTMLElement {
      connectedCallback() {
        if (this.dataset.initialized === 'true') return;
        this.dataset.initialized = 'true';
        this.tabs = Array.from(this.querySelectorAll('[data-room-tab]'));
        this.panels = Array.from(this.querySelectorAll('[data-room-panel]'));
        this.tabs.forEach((tab) => {
          tab.addEventListener('click', () => this.selectRoom(tab.dataset.roomTab));
          tab.addEventListener('keydown', (event) => this.handleTabKeys(event, tab));
        });
        this.querySelectorAll('[data-room-product-form]').forEach((form) => this.prepareProduct(form));
        this.querySelectorAll('[data-room-add-all]').forEach((button) => button.addEventListener('click', () => this.addAllToBag(button)));
        this.prepareFit();
        const availableDefault = this.tabs.find((tab) => tab.dataset.roomTab === this.dataset.defaultRoom) || this.tabs[0];
        if (availableDefault) this.selectRoom(availableDefault.dataset.roomTab, false);
      }

      selectRoom(room, focus = true) {
        this.tabs.forEach((tab) => {
          const active = tab.dataset.roomTab === room;
          tab.setAttribute('aria-selected', active ? 'true' : 'false');
          tab.tabIndex = active ? 0 : -1;
          if (active && focus) tab.focus();
        });
        this.panels.forEach((panel) => { panel.hidden = panel.dataset.roomPanel !== room; });
        if (this.fitState) this.applyFit(false);
      }

      handleTabKeys(event, current) {
        if (!['ArrowLeft', 'ArrowRight', 'Home', 'End'].includes(event.key)) return;
        event.preventDefault();
        const currentIndex = this.tabs.indexOf(current);
        let nextIndex = currentIndex;
        if (event.key === 'ArrowRight') nextIndex = (currentIndex + 1) % this.tabs.length;
        if (event.key === 'ArrowLeft') nextIndex = (currentIndex - 1 + this.tabs.length) % this.tabs.length;
        if (event.key === 'Home') nextIndex = 0;
        if (event.key === 'End') nextIndex = this.tabs.length - 1;
        this.selectRoom(this.tabs[nextIndex].dataset.roomTab);
      }

      prepareFit() {
        const fit = this.querySelector('[data-room-fit]');
        if (!fit) return;
        const scopeInputs = Array.from(fit.querySelectorAll('[data-room-fit-scope]'));
        const height = fit.querySelector('[data-room-fit-height]');
        const weight = fit.querySelector('[data-room-fit-weight]');
        const waist = fit.querySelector('[data-room-fit-waist]');
        const storedHeight = Number(window.localStorage?.getItem('oneboneRoomFitHeight'));
        const storedWeight = Number(window.localStorage?.getItem('oneboneRoomFitWeight'));
        const storedWaist = window.localStorage?.getItem('oneboneRoomFitWaist');
        const storedScope = window.localStorage?.getItem('oneboneRoomFitScope');
        if (height && storedHeight >= 61 && storedHeight <= 84) height.value = String(storedHeight);
        if (weight && storedWeight >= 140 && storedWeight <= 500) weight.value = String(storedWeight);
        if (waist && storedWaist && Array.from(waist.options).some((option) => option.value === storedWaist)) waist.value = storedWaist;
        if (storedScope) {
          const storedScopeInput = scopeInputs.find((input) => input.value === storedScope);
          if (storedScopeInput) storedScopeInput.checked = true;
        }
        this.fitState = {
          fit,
          scopeInputs,
          height,
          weight,
          waist,
          heightOutput: fit.querySelector('[data-room-fit-height-output]'),
          weightOutput: fit.querySelector('[data-room-fit-weight-output]'),
          topControls: Array.from(fit.querySelectorAll('[data-room-fit-top-control]')),
          bottomControls: Array.from(fit.querySelectorAll('[data-room-fit-bottom-control]')),
          topResult: fit.querySelector('[data-room-fit-top-result]'),
          bottomResult: fit.querySelector('[data-room-fit-bottom-result]'),
          topSize: fit.querySelector('[data-room-fit-top-size]'),
          bottomSize: fit.querySelector('[data-room-fit-bottom-size]'),
          status: fit.querySelector('[data-room-fit-status]')
        };
        scopeInputs.forEach((input) => input.addEventListener('change', () => this.updateFit()));
        height?.addEventListener('input', () => this.updateFit());
        weight?.addEventListener('input', () => this.updateFit());
        waist?.addEventListener('change', () => this.updateFit());
        this.updateFit(false);
      }

      getFitScope() {
        return this.fitState?.scopeInputs.find((input) => input.checked)?.value || 'both';
      }

      recommendTopSize(inches, pounds) {
        const matrix = [
          { max: 179, sizes: ['-2','-2','-2','-1','-1','-1','-1'] },
          { max: 189, sizes: ['-1','-1','-1','-1','-1','-1','-1'] },
          { max: 199, sizes: ['0','0','-1','-1','-1','-1','-1'] },
          { max: 249, sizes: ['0','0','0','0','0','0','0'] },
          { max: 259, sizes: ['1','1','1','0','0','0','0'] },
          { max: 269, sizes: ['1','1','1','1','1','1','1'] },
          { max: 279, sizes: ['2','1','1','1','1','1','1'] },
          { max: 289, sizes: ['2','2','1','1','1','1','1'] },
          { max: 309, sizes: ['2','2','1','1','1','1','1'] },
          { max: 319, sizes: ['3','3','2','2','2','1','1'] },
          { max: 329, sizes: ['3','3','2','2','2','2','2'] },
          { max: 339, sizes: ['3','3','3','3','3','3','3'] },
          { max: 359, sizes: ['4','4','3','3','3','3','3'] },
          { max: 379, sizes: ['4','4','4','4','4','4','4'] },
          { max: 389, sizes: ['5','5','4','4','4','3','3'] },
          { max: 399, sizes: ['5','5','5','4','4','4','4'] },
          { max: 429, sizes: ['5','5','5','5','5','5','5'] },
          { max: 439, sizes: ['6','5','5','5','5','5','5'] },
          { max: 489, sizes: ['6','6','6','6','6','6','6'] },
          { max: Infinity, sizes: ['7','7','7','7','7','7','7'] }
        ];
        const column = inches <= 68 ? 0 : inches <= 71 ? 1 : inches <= 74 ? 2 : inches <= 77 ? 3 : inches <= 80 ? 4 : inches <= 83 ? 5 : 6;
        return (matrix.find((range) => pounds <= range.max) || matrix[matrix.length - 1]).sizes[column];
      }

      updateFit(announce = true) {
        const state = this.fitState;
        if (!state) return;
        const scope = this.getFitScope();
        const inches = Number(state.height?.value || 72);
        const pounds = Number(state.weight?.value || 260);
        const topSize = this.recommendTopSize(inches, pounds);
        const bottomSize = state.waist?.value || 'B';
        const showTops = scope === 'tops' || scope === 'both';
        const showBottoms = scope === 'bottoms' || scope === 'both';
        state.topControls.forEach((control) => { control.hidden = !showTops; });
        state.bottomControls.forEach((control) => { control.hidden = !showBottoms; });
        if (state.topResult) state.topResult.hidden = !showTops;
        if (state.bottomResult) state.bottomResult.hidden = !showBottoms;
        if (state.heightOutput) state.heightOutput.textContent = `${Math.floor(inches / 12)}'${inches % 12}\"`;
        if (state.weightOutput) state.weightOutput.textContent = pounds >= 500 ? '500 lb+' : `${pounds} lb`;
        if (state.topSize) state.topSize.textContent = topSize;
        if (state.bottomSize) state.bottomSize.textContent = bottomSize;
        this.currentFit = { scope, topSize, bottomSize };
        try {
          window.localStorage?.setItem('oneboneRoomFitHeight', String(inches));
          window.localStorage?.setItem('oneboneRoomFitWeight', String(pounds));
          window.localStorage?.setItem('oneboneRoomFitWaist', bottomSize);
          window.localStorage?.setItem('oneboneRoomFitScope', scope);
          if (showTops) window.localStorage?.setItem('sizeTop', topSize);
          if (showBottoms) window.localStorage?.setItem('sizeBottom', bottomSize);
        } catch (error) {
          // Sizing still works when storage is unavailable.
        }
        this.applyFit(announce);
      }

      normalizeFitSize(value) {
        const clean = String(value || '').toUpperCase().replace(/^SIZE\s*/, '').trim();
        const numeric = clean.match(/^-?\d+/);
        if (numeric) return numeric[0];
        const letter = clean.match(/^([A-H])(?:$|[\s(/-])/);
        return letter ? letter[1] : clean;
      }

      applyFit(announce = true) {
        const state = this.fitState;
        const fit = this.currentFit;
        if (!state || !fit) return;
        const activePanel = this.panels.find((panel) => !panel.hidden);
        if (!activePanel) return;
        const targets = [];
        if (fit.scope === 'tops' || fit.scope === 'both') targets.push(fit.topSize);
        if (fit.scope === 'bottoms' || fit.scope === 'both') targets.push(fit.bottomSize);
        let selected = 0;
        let unavailable = 0;
        activePanel.querySelectorAll('[data-room-variant]').forEach((select) => {
          const matching = Array.from(select.options).find((option) => targets.includes(this.normalizeFitSize(option.dataset.roomSize)));
          if (!matching) return;
          if (matching.disabled) {
            if (select.value !== matching.value) {
              select.value = matching.value;
              select.dispatchEvent(new Event('change', { bubbles: true }));
            }
            unavailable += 1;
            return;
          }
          if (select.value !== matching.value) {
            select.value = matching.value;
            select.dispatchEvent(new Event('change', { bubbles: true }));
          }
          selected += 1;
        });
        if (!announce || !state.status) return;
        if (selected > 0) {
          state.status.textContent = `${this.dataset.fitAppliedLabel || 'YOUR SIZE IS SELECTED IN'} ${selected} ${selected === 1 ? 'PIECE' : 'PIECES'}.${unavailable ? ` ${unavailable} ${this.dataset.fitUnavailableLabel || 'MATCHING OPTION UNAVAILABLE'}.` : ''}`;
        } else {
          state.status.textContent = this.dataset.fitNoMatchLabel || 'YOUR FIT IS SAVED. NO MATCHING SIZE IS AVAILABLE IN THIS ROOM.';
        }
      }

      async addAllToBag(button) {
        const panel = button.closest('[data-room-panel]');
        const message = panel?.querySelector('[data-room-add-all-message]');
        if (!panel) return;
        const items = Array.from(panel.querySelectorAll('[data-room-product-form]')).flatMap((form) => {
          const addButton = form.querySelector('[data-room-add]');
          const idInput = form.querySelector('[name="id"]');
          if (!idInput?.value || addButton?.disabled) return [];
          return [{ id: Number(idInput.value), quantity: 1 }];
        });
        if (!items.length) {
          if (message) message.textContent = this.dataset.noAvailableLabel || 'NO AVAILABLE PIECES TO ADD.';
          return;
        }
        const originalLabel = button.textContent;
        button.disabled = true;
        button.textContent = this.dataset.addingAllLabel || 'ADDING THE ROOM…';
        if (message) message.textContent = '';
        try {
          const helper = window.Alpine?.store?.('xCartHelper');
          const payload = { items };
          if (helper) {
            payload.sections = helper.getSectionsToRender().map((section) => section.id);
            payload.sections_url = window.location.pathname;
          }
          const endpoint = window.Eurus?.cart_add_url || `${window.Shopify?.routes?.root || '/'}cart/add.js`;
          const response = await fetch(endpoint, {
            method: 'POST',
            headers: { Accept: 'application/javascript', 'Content-Type': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
            body: JSON.stringify(payload)
          });
          const result = await response.json();
          if (!response.ok || result.status === 422) throw new Error(result.description || this.dataset.errorLabel);
          if (helper && result.sections) helper.reRenderSections(result.sections);
          const miniCart = window.Alpine?.store?.('xMiniCart');
          if (miniCart) miniCart.openCart();
          document.dispatchEvent(new CustomEvent('eurus:cart:items-changed'));
          document.dispatchEvent(new CustomEvent('eurus:cart:redirect'));
          const success = (this.dataset.addedAllLabel || '[count] PIECES ADDED TO YOUR BAG.').replace('[count]', String(items.length));
          button.textContent = success;
          if (message) message.textContent = success;
          window.setTimeout(() => { button.textContent = originalLabel; }, 1800);
        } catch (error) {
          button.textContent = originalLabel;
          if (message) message.textContent = error.message || this.dataset.errorLabel || 'PLEASE TRY AGAIN.';
        } finally {
          button.disabled = false;
        }
      }

      prepareProduct(form) {
        const variant = form.querySelector('[data-room-variant]');
        const price = form.closest('article')?.querySelector('[data-room-price]');
        const button = form.querySelector('[data-room-add]');
        const message = form.querySelector('[data-room-message]');
        variant?.addEventListener('change', () => {
          const selected = variant.options[variant.selectedIndex];
          if (price && selected?.dataset.price) price.textContent = selected.dataset.price;
          if (button) button.disabled = selected?.disabled || !variant.value;
          if (message) message.textContent = '';
        });
        form.addEventListener('submit', async (event) => {
          event.preventDefault();
          if (!button || button.disabled) return;
          const originalLabel = button.textContent;
          button.disabled = true;
          button.textContent = this.dataset.addingLabel || 'ADDING…';
          if (message) message.textContent = '';
          const formData = new FormData(form);
          try {
            const helper = window.Alpine?.store?.('xCartHelper');
            if (helper) {
              formData.append('sections', helper.getSectionsToRender().map((section) => section.id));
              formData.append('sections_url', window.location.pathname);
            }
            const endpoint = window.Eurus?.cart_add_url || `${window.Shopify?.routes?.root || '/'}cart/add.js`;
            const response = await fetch(endpoint, {
              method: 'POST',
              headers: { Accept: 'application/javascript', 'X-Requested-With': 'XMLHttpRequest' },
              body: formData
            });
            const result = await response.json();
            if (!response.ok || result.status === 422) throw new Error(result.description || this.dataset.errorLabel);
            if (helper && result.sections) helper.reRenderSections(result.sections);
            const notice = window.Alpine?.store?.('xCartNoti');
            if (notice?.enable) notice.setItem(result);
            const miniCart = window.Alpine?.store?.('xMiniCart');
            if (miniCart && !notice?.enable) miniCart.openCart();
            document.dispatchEvent(new CustomEvent('eurus:cart:items-changed'));
            document.dispatchEvent(new CustomEvent('eurus:cart:redirect'));
            button.textContent = this.dataset.addedLabel || 'ADDED';
            if (message) message.textContent = this.dataset.addedLabel || 'ADDED TO YOUR BAG.';
            window.setTimeout(() => { button.textContent = originalLabel; }, 1600);
          } catch (error) {
            button.textContent = originalLabel;
            if (message) message.textContent = error.message || this.dataset.errorLabel || 'PLEASE TRY AGAIN.';
          } finally {
            button.disabled = false;
          }
        });
      }
    }
    customElements.define('onebone-room-shopper', OneboneRoomShopper);
  }
  } catch(e) { console.error(e); }
})();

})();
